<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Cadastrar conta'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Dados Bancários'" :SubSessao="'Cadastrar conta'" />
                    <span>
                        Ao menos uma conta deverá ser informada. Caso queria, poderá adicionar mais contas.
                    </span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="nome">Banco*</label>
                            <select id="tipoCadastro" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="dadosBancariosContaPrincipal.NomeBanco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaBancos" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Codigo + ' - ' + item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroBanco" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Tipo de conta*</label>
                            <select id="tipoConta" @change="salvarAlteracoesLocalmente"
                                v-model="dadosBancariosContaPrincipal.TipoConta" class="field">
                                <option value="Conta Corrente">Conta Corrente</option>
                                <option value="Conta Poupança">Conta Poupança</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Agência*</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" type="text"
                                v-model="dadosBancariosContaPrincipal.Agencia" id="nome" placeholder="">
                            <p v-if="camposObrigatorios.erroAgencia" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Dígito</label>
                            <input class="field" @change="salvarAlteracoesLocalmente"
                                v-model="dadosBancariosContaPrincipal.AgenciaDigito" type="text" id="nome"
                                placeholder="">
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Conta*</label>
                            <input class="field" @change="salvarAlteracoesLocalmente"
                                v-model="dadosBancariosContaPrincipal.ContaCorrente" type="text" id="nome"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroContaCorrente" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Dígito*</label>
                            <input class="field" @change="salvarAlteracoesLocalmente"
                                v-model="dadosBancariosContaPrincipal.ContaCorrenteDigito" type="text" id="nome"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroContaCorrenteDigito" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%; display: inline-flex">
                            <input type="checkbox" class="accept" name="" id="accept"
                                v-model="dadosBancariosContaPrincipal.Principal" @change="salvarAlteracoesLocalmente"
                                disabled="true" />
                            <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Conta
                                principal</label>
                        </div>
                        <div class="label__field" style="width: 18%; display: inline-flex">

                            <input type="checkbox" class="accept" name="" id="ContaConjunta"
                                v-model="dadosBancariosContaPrincipal.ContaConjunta"
                                @change="salvarAlteracoesLocalmente" />
                            <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Conta
                                conjunta</label>
                        </div>
                        <div class="label__field" style="width: 25%; display: inline-flex"
                            v-if="dadosBancariosContaPrincipal.ContaConjunta">
                            <input type="checkbox" class="accept" name="" id="Titular" v-model="Titular"
                                @change="salvarAlteracoesLocalmente" />
                            <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Titular</label>
                        </div>
                        <div class="label__field" style="width: 25%; display: inline-flex"
                            v-if="dadosBancariosContaPrincipal.ContaConjunta">
                            <input type="checkbox" class="accept" name="" id="Cotitular" v-model="Cotitular"
                                @change="salvarAlteracoesLocalmente" />
                            <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Cotitular</label>
                        </div>
                    </div>
                    <div class="row" v-if="dadosBancariosContaPrincipal.ContaConjunta">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Nome completo</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" type="text"
                                v-model="dadosBancariosContaPrincipal.NomeCompleto" id="nome" placeholder="">
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">CPF</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-mask="'###.###.###-##'"
                                v-model="dadosBancariosContaPrincipal.CpfContaConjunta" type="text" id="nome"
                                placeholder="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="footerFormulario" v-if="contas.length == 0">
                <div class="buttonsAcoes">
                    <button class="btnDefault" @click="addContaBancaria">Adicionar nova conta</button>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <h5 v-if="contas.length > 0">Conta adicional</h5>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div v-for="(conta, index) in contas" :key="conta.Guid" class="empresaItem"
                        style="  border-bottom: 1px solid #EAECF0; margin-bottom: 20px;">
                        <div class="row">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="nome">Banco*</label>
                                <select id="tipoCadastro" @change="salvarAlteracoesLocalmente"
                                    class="field" v-model="conta.NomeBanco">
                                    <option value="">Selecione</option>
                                    <option v-for="item in listaBancos" :key="item.Codigo" :value="item.Codigo">
                                        {{ item.Codigo + ' - ' + item.Descricao }}
                                    </option>
                                </select>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="nome">Tipo de conta*</label>
                                <select id="tipoConta" @change="salvarAlteracoesLocalmente"
                                    v-model="conta.TipoConta" class="field">
                                    <option value="Conta Corrente">Conta Corrente</option>
                                    <option value="Conta Poupança">Conta Poupança</option>
                                </select>

                            </div>

                            <div class="label__field" style="width: 20%; margin-top: 30px; margin-left: 30px;">
                                <a @click.stop.prevent="excluirContaBancaria(index)" class="ico__delete"
                                    title="Excluir conta">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">Agência*</label>
                                <input class="field" @change="salvarAlteracoesLocalmente" type="text"
                                    v-model="conta.Agencia" id="nome" placeholder="">
                            </div>
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">Dígito</label>
                                <input class="field" @change="salvarAlteracoesLocalmente"
                                    v-model="conta.AgenciaDigito" type="text" id="nome" placeholder="">
                            </div>
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">Conta*</label>
                                <input class="field" @change="salvarAlteracoesLocalmente"
                                    v-model="conta.ContaCorrente" type="text" id="nome" placeholder="">
                            </div>
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">Dígito*</label>
                                <input class="field" @change="salvarAlteracoesLocalmente"
                                    v-model="conta.ContaCorrenteDigito" type="text" id="nome" placeholder="">
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 25%; display: inline-flex">
                                <input type="checkbox" class="accept" name="" id="accept" v-model="conta.Principal"
                                    @change="salvarAlteracoesLocalmente" disabled="true" />
                                <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Conta
                                    principal</label>
                            </div>
                            <div class="label__field" style="width: 18%; display: inline-flex">
                                <input type="checkbox" class="accept" :name="`ContaConjunta_${index}`"
                                    id="ContaConjunta" v-model="conta.ContaConjunta"
                                    @change="salvarAlteracoesLocalmente" />
                                <label class="label" style="margin-top: 6px; margin-left: 5px;" for="nome">Conta
                                    conjunta</label>
                            </div>
                            <div class="label__field" style="width: 25%; display: inline-flex"
                                v-if="conta.ContaConjunta">
                                <input type="checkbox" class="accept" :name="`Titular_${index}`" id="Titular"
                                    :checked="contas[index].TipoContaConjunta == 1"
                                    @click="updateTipoContaConjunta('titular', index, $event)"
                                    @change="salvarAlteracoesLocalmente" />
                                <label class="label" style="margin-top: 6px; margin-left: 5px;"
                                    for="nome">Titular</label>
                            </div>
                            <div class="label__field" style="width: 25%; display: inline-flex"
                                v-if="conta.ContaConjunta">
                                <input type="checkbox" class="accept" :name="`Cotitular_${index}`"
                                    :checked="contas[index].TipoContaConjunta == 2"
                                    @click="updateTipoContaConjunta('cotitular', index, $event)"
                                    @change="salvarAlteracoesLocalmente" />
                                <label class="label" style="margin-top: 6px; margin-left: 5px;"
                                    for="nome">Cotitular</label>
                            </div>
                        </div>
                        <div class="row" v-if="conta.ContaConjunta">
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">Nome completo</label>
                                <input class="field" @change="salvarAlteracoesLocalmente" type="text"
                                    v-model="conta.NomeCompleto" id="nome" placeholder="">
                            </div>
                            <div class="label__field" style="width: 25%">
                                <label class="label" for="nome">CPF</label>
                                <input class="field" @change="salvarAlteracoesLocalmente"
                                    v-mask="'###.###.###-##'" v-model="conta.CpfContaConjunta" type="text" id="nome"
                                    placeholder="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerFormulario" v-if="contas.length > 0">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="addContaBancaria">Adicionar nova conta</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import api from '@/api/axios';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    name: 'CadastroPF_DadosBancarios',
    props: ['Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            listaBancos: 'GET_LISTA_BANCOS',
            infoBancarios: 'GET_PF_INFO_BANCARIOS',
            localPfLocalObjSalvo: 'GET_PF_SALVAR_INFO_BANCARIAS'
        }),
    },
    data() {
        return {
            permitirAvancar: false,
            Titular: false,
            Cotitular: false,
            contas: [],
            camposObrigatorios: {
                erroContaCorrenteDigito: false,
                erroContaCorrente: false,
                erroAgencia: false,
                erroBanco: false,
            },
            dadosBancariosContaPrincipal: {
                Guid: '',
                ClienteId: 0,
                NomeBanco: '',
                Agencia: '',
                AgenciaDigito: '',
                ContaCorrente: '',
                ContaCorrenteDigito: '',
                Principal: true,
                ContaConjunta: false,
                TipoContaConjunta: 0,
                TipoConta: 'conta corrente',
                NomeCompleto: '',
                CpfContaConjunta: ''
            }
        }
    },
    created() {
        if (this.infoBancarios.length > 0) {
            const contaPrincipal = this.infoBancarios.find(conta => conta.Principal === true);
            if (contaPrincipal) {
                this.dadosBancariosContaPrincipal = contaPrincipal;
                this.contas = this.infoBancarios.filter(conta => conta !== contaPrincipal);
            }
            if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 1) {
                this.Titular = true;
            }
            if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 2) {
                this.Cotitular = true;
            }
        }
        this.dadosBancariosContaPrincipal.ClienteId = this.user.ClienteId;
    },
    mounted() {
        if (this.localPfLocalObjSalvo != null && this.localPfLocalObjSalvo.ClienteId == this.dadosBancariosContaPrincipal.ClienteId) {
            this.dadosBancariosContaPrincipal = this.localPfLocalObjSalvo;
            if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 1) {
                this.Titular = true;
            }
            if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 2) {
                this.Cotitular = true;
            }
        }
        this.dadosBancariosContaPrincipal.ClienteId = this.user.ClienteId;
        this.validarFormulario(false);
    },
    methods: {
        addContaBancaria() {
            this.novaConta = {
                Guid: '',
                ClienteId: this.user.ClienteId,
                NomeBanco: '',
                Agencia: '',
                AgenciaDigito: '',
                ContaCorrente: '',
                ContaCorrenteDigito: '',
                Principal: false,
                ContaConjunta: false,
                TipoContaConjunta: 0,
                TipoConta: 'conta corrente',
                NomeCompleto: '',
                CpfContaConjunta: ''
            };
            this.contas.push({ ...this.novaConta });
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 4);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        updateTipoContaConjunta(param, index, event) {
            if (param == 'titular') {
                this.contas[index].TipoContaConjunta = event.target.checked ? 1 : 2;
            } else if (param == 'cotitular') {
                this.contas[index].TipoContaConjunta = event.target.checked ? 2 : 1;
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroContaCorrenteDigito: false,
                erroContaCorrente: false,
                erroAgencia: false,
                erroBanco: false,
            };
            if (!this.dadosBancariosContaPrincipal.NomeBanco
                || !this.dadosBancariosContaPrincipal.Agencia
                || !this.dadosBancariosContaPrincipal.ContaCorrente
                || !this.dadosBancariosContaPrincipal.ContaCorrenteDigito) {
                if (!this.dadosBancariosContaPrincipal.NomeBanco) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroBanco = true;
                        nomeDoCampo = 'Banco';
                        this.permitirAvancar = false;
                    }
                }
                if (!this.dadosBancariosContaPrincipal.Agencia) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroAgencia = true;
                        nomeDoCampo = 'Agência';
                        this.permitirAvancar = false;
                    }
                }
                if (!this.dadosBancariosContaPrincipal.ContaCorrente) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroContaCorrente = true;
                        nomeDoCampo = 'Conta';
                        this.permitirAvancar = false;
                    }
                }
                if (!this.dadosBancariosContaPrincipal.ContaCorrenteDigito) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroContaCorrenteDigito = true;
                        nomeDoCampo = 'Dígito da Conta Corrente';
                        this.permitirAvancar = false;
                    }
                }
            }
            this.contas.forEach((c, index) => {
                if (!c.NomeBanco) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Banco da conta adicional ' + (index + 1);
                    }
                    this.permitirAvancar = false;
                }
                if (!c.Agencia) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Agência da conta adicional ' + (index + 1);
                    }
                    this.permitirAvancar = false;
                }
                if (!c.ContaCorrente) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Número da conta adicional ' + (index + 1);
                    }
                    this.permitirAvancar = false;
                }
                if (!c.ContaCorrenteDigito) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Dígito da conta adicional ' + (index + 1);
                    }
                    this.permitirAvancar = false;
                }
            });
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        salvarAlteracoesLocalmente() {
            // Array para armazenar todas as contas
            let todasContas = [];
            
            // Processar a conta principal
            if (this.dadosBancariosContaPrincipal) {
                // Limpar campos de conta conjunta se não for conjunta
                if (this.dadosBancariosContaPrincipal.ContaConjunta != true) {
                    this.dadosBancariosContaPrincipal.NomeCompleto = '';
                    this.dadosBancariosContaPrincipal.CpfContaConjunta = '';
                    this.dadosBancariosContaPrincipal.TipoContaConjunta = '0';
                }
                
                // Garantir que seja marcada como principal
                this.dadosBancariosContaPrincipal.Principal = true;
                
                // Adicionar ao array de todas as contas
                todasContas.push(this.dadosBancariosContaPrincipal);
            }
            
            // Processar as contas adicionais
            if (this.contas && this.contas.length > 0) {
                const contasAdicionais = this.contas.filter(conta => conta.Principal == false);
                
                contasAdicionais.forEach(c => {
                    // Limpar campos de conta conjunta se não for conjunta
                    if (c.ContaConjunta != true) {
                        c.NomeCompleto = '';
                        c.CpfContaConjunta = '';
                        c.TipoContaConjunta = '0';
                    }
                    
                    // Garantir que não seja marcada como principal
                    c.Principal = false;
                    
                    // Adicionar ao array de todas as contas
                    todasContas.push(c);
                });
            }
            
            // Salvar todas as contas no store
            this.$store.commit('SET_PF_SALVAR_INFO_BANCARIAS', todasContas);
            
            // Validar o formulário
            this.validarFormulario(false);
        },
        async excluirContaBancaria(index) {
            this.disableBtn = true;
             
            if (this.contas[index].Guid == '') {
                this.contas.splice(index, 1);
                this.salvarAlteracoesLocalmente();
                return;
            }
            await api.get(`PessoaFisica/dadosBancarios/excluir?guid=${this.contas[index].Guid}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.contas.splice(index, 1);
                        this.salvarAlteracoesLocalmente();
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
    },
    watch: {
        Titular() {
            if (this.Titular) {
                this.dadosBancariosContaPrincipal.TipoContaConjunta = 1;
                this.Cotitular = false;
            }
        },
        Cotitular() {
            if (this.Cotitular) {
                this.dadosBancariosContaPrincipal.TipoContaConjunta = 2;
                this.Titular = false;
            }
        },
        infoBancarios() {
            if (this.infoBancarios.length > 0) {
                const contaPrincipal = this.infoBancarios.find(conta => conta.Principal === true);
                if (contaPrincipal) {
                    this.dadosBancariosContaPrincipal = contaPrincipal;
                    this.contas = this.infoBancarios.filter(c => c.Principal === false);
                }
                if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 1) {
                    this.Titular = true;
                }
                if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 2) {
                    this.Cotitular = true;
                }
            }
            this.dadosBancariosContaPrincipal.ClienteId = this.user.ClienteId;
        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #F9FAFB;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}

.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>